import React, { createContext, useContext, useEffect, useState } from 'react';

const ConfigContext = createContext();

let configValue = null; // Add this for external access

export const ConfigProvider = ({ children }) => {
    const [config, setConfig] = useState(null);

    useEffect(() => {
        const fetchConfig = async () => {
            try {
                const response = await fetch('/config.json');
                const data = await response.json();
                setConfig(data);
                configValue = data; // Store config globally
            } catch (error) {
                console.error('Error loading config:', error);
            }
        };

        fetchConfig();
    }, []);

    if (!config) return <div>Loading configuration...</div>;

    return (
        <ConfigContext.Provider value={config}>
            {children}
        </ConfigContext.Provider>
    );
};

export const useConfig = () => useContext(ConfigContext);

export const getConfig = () => configValue;
